module.exports = __webpack_public_path__ + "static/media/ukraine.c9b64275.png";